/**
 * The categorical colour scale, shared by every surface that draws one
 * destination beside another: the split bar, the resolver's simulation table
 * and the traffic chart.
 *
 * It lives here rather than inside any one of those components so that a
 * destination keeps the same colour wherever it appears — a reader comparing
 * the split bar against the traffic chart is relying on that.
 *
 * Eight steps, distinguishable in both themes and under the common
 * colour-vision deficiencies; the values themselves are tokens in tokens.css.
 */
const SERIES = [
  'var(--color-series-1)',
  'var(--color-series-2)',
  'var(--color-series-3)',
  'var(--color-series-4)',
  'var(--color-series-5)',
  'var(--color-series-6)',
  'var(--color-series-7)',
  'var(--color-series-8)',
] as const;

export const SERIES_LENGTH = SERIES.length;

/** Wraps, so an entry with more than eight destinations still renders. */
export function seriesColor(index: number): string {
  return SERIES[index % SERIES.length] as string;
}
